import { organisationConstants } from '../../_constants/organisation.constants';
import { adminOrgService } from '../../_services/organisation/adminList.service';

export const adminOrgActions = {
    getAdminList
};

function getAdminList(id, org) {
    return dispatch => {
        dispatch(request({
            id,
            org
        }));
        adminOrgService.getOrgAdminList(id, org)
            .then(
                admins => {

                    dispatch(success(admins));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request(requested) { return { type: organisationConstants.REQUEST_ORG_ADMIN, payload: requested } }
    function success(organisationAdmins) { return { type: organisationConstants.RECEIVE_ORG_ADMIN, organisationAdmins } }
    function failure(error) { return { type: organisationConstants.ADMIN_ORG_ERROR, error } }
}


// WEBPACK FOOTER //
// ./src/_actions/organisations/orgAdminList.action.js